import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetTags, actionDeleteTag } from "../actions/TagActions"
import { LOGIN_ROUTE, TAGS_ADD_ROUTE, TAGS_EDIT_ROUTE } from "../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import ColorIcon from "@material-ui/icons/FiberManualRecord";
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Util, { SUCCESS, ERROR } from '../common/Util'


class Tags extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, tags:[], filter:"", tagForDelete:false}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeleteTagSuccess=this.getDeleteTagSuccess.bind(this)
    this.onConfirmDeleteTag=this.onConfirmDeleteTag.bind(this)
    this.onAddTag=this.onAddTag.bind(this)
    this.onSearch=this.onSearch.bind(this)
  }

  componentWillMount(){
    if (this.props.login) {
      // console.log("COMPONENT WILL MOUNT")
      this.props.actionGetTags(this.onChangePage, this.getTagsError)
    }
  }

  getTagsError(e){
    console.log("ERROR Tags", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los tags.")
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let tags = this.props.tagList.filter((e)=>{return e.tagName.match(filter)})
    let count = tags.length
    tags = tags.slice(from, end)
    this.setState({page:newPage, count:count, tags:tags})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let tags = this.props.tagList.filter((e)=>{return e.tagName.match(filter)})
    let count = tags.length
    tags = tags.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, tags:tags})
  }

  onSearch(evt){
   this.setState({filter:evt.target.value},this.onChangePage)
  }

  onAddTag(){
    this.props.history.push(TAGS_ADD_ROUTE)
  }

  onEditTag(tag){
    this.props.history.push(TAGS_EDIT_ROUTE, tag)
  }

  onConfirmDeleteTag(){
    this.props.actionDeleteTag(this.state.tagForDelete.id,this.getDeleteTagSuccess,this.getDeleteTagError)
    this.setState({tagForDelete:false})
  }
  
  onDeleteTag(tag){
    this.setState({tagForDelete:tag})  
  }

  getDeleteTagSuccess(){
    this.props.actionGetTags(()=>{
      Util.showNoty(SUCCESS, "El tag se eliminó correctamente.")
      this.onChangePage(null,this.state.page)
    }, this.getTagsError)
  }

  getDeleteTagError(e){
    console.log("ERROR", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar el tag.")
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Nombre","Color", "¿Es visible?"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let tags = this.state.tags
    // console.log("tags LIST", tags, this.props.tagList)
    if(!tags||tags.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return tags.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.tagName}</TableCell>
          <TableCell>            
            <ColorIcon style={{ color: item.tagColor }} />
          </TableCell>
          <TableCell>{item.isTagVisible?"SI":"NO"}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            <Tooltip title="Editar tag">
              <IconButton onClick={this.onEditTag.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar tag">
              <IconButton onClick={this.onDeleteTag.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, tagList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Tags</Typography>
          <Typography variant="subtitle1">Crea tags</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de tags</Typography>
            <Toolbar style={theme.table.toolbar}>
              <Tooltip title="Crear nuevo tag">
                <Fab color="primary" onClick={this.onAddTag} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
              <Table stickyHeader>
                <TableHead > 
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody>
                  {this.renderTableBody()}
                </TableBody>
              </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.tagForDelete}>
            <DialogTitle>Eliminar tag {this.state.tagForDelete&&this.state.tagForDelete.tagName||""}</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar el tag {this.state.tagForDelete&&this.state.tagForDelete.tagName||""} ?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="secondary" onClick={()=>{this.setState({tagForDelete:null})}}>Cancelar</Button>
              <Button variant="contained" color="primary" onClick={this.onConfirmDeleteTag}>Eliminar</Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  // console.log("STORE", store)
  return {
    login: store.auth.login,
    tagList: store.tag.tagList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetTags,
      actionDeleteTag
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Tags)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/Tags.js